import { render, staticRenderFns } from "./ConsignadoAberto.vue?vue&type=template&id=4432580a&"
import script from "./ConsignadoAberto.vue?vue&type=script&lang=js&"
export * from "./ConsignadoAberto.vue?vue&type=script&lang=js&"
import style0 from "./ConsignadoAberto.vue?vue&type=style&index=0&id=4432580a&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports